import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const SplitOneIcon: SVGFC = ({ color = tailwindColors.red.DEFAULT, ...props }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_19469_46075)">
        <path
          d="M6.5 0.624707L6.5 4.19971C6.5 4.47471 6.275 4.69971 6 4.69971C5.725 4.69971 5.5 4.47471 5.5 4.19971L5.5 0.599708C5.5 0.324708 5.725 0.0997076 6 0.0997076C6.275 0.0997076 6.5 0.349707 6.5 0.624707Z"
          fill={color}
        />
        <path
          d="M6.49965 7.8L6.49965 11.375C6.49965 11.65 6.27465 11.875 5.99965 11.875C5.72465 11.875 5.49965 11.65 5.49965 11.375L5.49965 7.775C5.49965 7.5 5.72465 7.275 5.99965 7.275C6.27465 7.275 6.49965 7.525 6.49965 7.8ZM8.02464 2.325C8.02464 2.45 7.97464 2.6 7.84964 2.7C7.64964 2.875 7.34964 2.875 7.14964 2.65L5.97464 1.35L4.79965 2.65C4.62465 2.85 4.29964 2.875 4.09964 2.7C3.89964 2.525 3.87465 2.2 4.04965 2L5.57464 0.275C5.67464 0.174999 5.79964 0.1 5.94964 0.1C6.09964 0.1 6.22464 0.15 6.32464 0.275L7.89964 2C7.97464 2.1 8.02464 2.225 8.02464 2.325Z"
          fill={color}
        />
        <path
          d="M8.025 9.6749C8.025 9.7999 7.975 9.8999 7.9 9.9999L6.375 11.7249C6.275 11.8249 6.15 11.8999 6 11.8999C5.85 11.8999 5.725 11.8499 5.625 11.7249L4.1 9.9999C3.925 9.7999 3.95 9.4999 4.15 9.2999C4.35 9.1249 4.65 9.1249 4.85 9.3499L6 10.6499L7.175 9.3499C7.35 9.1499 7.675 9.1249 7.875 9.2999C7.975 9.3999 8.025 9.5249 8.025 9.6749ZM11.875 5.9999C11.875 6.2749 11.65 6.4999 11.375 6.4999L0.625 6.4999C0.35 6.4999 0.125 6.2749 0.125 5.9999C0.125 5.7249 0.35 5.4999 0.625 5.4999L11.4 5.4999C11.65 5.4999 11.875 5.7249 11.875 5.9999Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19469_46075">
          <rect width="12" height="12" fill="white" transform="translate(0 12) rotate(-90)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SplitOneIcon
